// R1c dead-click fix F1+F2 (Round 2) — Client Portal placeholder.
// Owner impersonation of CLIENT role lands here (no more 404). The real
// Client Portal shell (invoice view, milestone timeline, sign & pay flows)
// is not implemented. Copy is truthful — no fake tiles, no decorative buttons.
import React from "react";
import { AdminAppShell } from "../../design-system/shells/AdminAppShell";
import { useAuth } from "../../lib/auth";
import { Card, CardContent } from "../../components/ui/card";
import { LifeBuoy, FileText, CreditCard, Milestone } from "lucide-react";

const R4_MODULES = [
  { icon: FileText,   title: "Contracts & Proposals", desc: "Signed docs the client can view + re-download at any time." },
  { icon: CreditCard, title: "Invoices & Payments",   desc: "Deposits, progress billings, ACH + card pay via Stripe." },
  { icon: Milestone,  title: "Project Milestones",    desc: "Live schedule, delivered vs pending phases, punch-list." },
  { icon: LifeBuoy,   title: "Request Support",       desc: "Client raises tickets, RFIs, and change-order questions." },
];

export default function ClientPortalPlaceholder() {
  const { user, impersonation } = useAuth();
  return (
    <AdminAppShell
      activeNav="command"
      title="Client Portal"
      subtitle={impersonation ? `Impersonation preview · ${impersonation.label}` : "Client-facing shell"}
      user={user}
    >
      <div
        className="border border-erf-gold/40 bg-erf-gold/10 text-erf-dark rounded-md px-4 py-3 mb-6 font-nav text-sm"
        data-testid="client-portal-r4-notice"
        role="status"
      >
        <strong className="font-display font-semibold">Client Portal shell — coming in R4.</strong>{" "}
        Owner impersonation lands here as a truthful preview. No fake tiles are shown.
        The real Client Portal (contracts, invoices, milestones, pay-link) is scheduled
        for release R4. To exit this view, use the top banner’s <em>Return to Owner</em> button.
      </div>

      <div className="grid gap-4 md:grid-cols-2" data-testid="client-portal-r4-modules">
        {R4_MODULES.map(({ icon: Icon, title, desc }) => (
          <Card key={title} className="border-erf-borderCream bg-erf-cream">
            <CardContent className="p-4 flex items-start gap-3">
              <div className="w-8 h-8 rounded-md bg-erf-dark text-erf-cream flex items-center justify-center shrink-0">
                <Icon className="w-4 h-4" aria-hidden="true" />
              </div>
              <div>
                <div className="font-display font-semibold text-erf-dark">{title}</div>
                <div className="text-xs font-nav text-erf-dark/70 mt-1">{desc}</div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-erf-gold mt-2">
                  Not Implemented
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </AdminAppShell>
  );
}
